import { render, staticRenderFns } from "./RegistrarOrdenPago.vue?vue&type=template&id=57364473&scoped=true&"
import script from "./RegistrarOrdenPago.vue?vue&type=script&lang=js&"
export * from "./RegistrarOrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57364473",
  null
  
)

export default component.exports